module.exports = __webpack_public_path__ + "static/img/Patrick-Carrigan.e5a4923.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Patrick-Carrigan.jpg
// module id = gCC9
// module chunks = 0